import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var KeywordGroup = /*#__PURE__*/lazy(function () {
  return import("pages/compare/keywordgroup/KeywordGroup");
});
var Hospitals = /*#__PURE__*/lazy(function () {
  return import("pages/compare/hospitals/Hospitals");
});
var InformationSources = /*#__PURE__*/lazy(function () {
  return import("pages/compare/informationSources/InformationSources");
});
var CompareByEntryId = /*#__PURE__*/lazy(function () {
  return import("pages/compare/byentryid/CompareByEntryId");
});
var Overview = /*#__PURE__*/lazy(function () {
  return import("pages/compare/overview/Overview");
});
var CompareByEntryIdRoutes = function CompareByEntryIdRoutes(props) {
  return /*#__PURE__*/_jsx(Routes, {
    children: /*#__PURE__*/_jsx(Route, {
      path: ":entryId",
      element: /*#__PURE__*/_jsx(CompareByEntryId, _objectSpread({}, props))
    })
  });
};
var KeywordGroupRoutes = function KeywordGroupRoutes(props) {
  return /*#__PURE__*/_jsxs(Routes, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: ":groupId",
      element: /*#__PURE__*/_jsx(KeywordGroup, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: ":entryName/*",
      element: /*#__PURE__*/_jsx(CompareByEntryIdRoutes, _objectSpread({}, props))
    })]
  });
};
var TypeRoutes = function TypeRoutes(props) {
  return /*#__PURE__*/_jsxs(Routes, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "oversikt",
      element: /*#__PURE__*/_jsx(Overview, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: ":entryName/*",
      element: /*#__PURE__*/_jsx(CompareByEntryIdRoutes, _objectSpread({}, props))
    })]
  });
};
export default function compareRoutes(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/jamfor/nyckelordsgrupp/*",
      element: /*#__PURE__*/_jsx(KeywordGroupRoutes, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/jamfor/sjukhus",
      element: /*#__PURE__*/_jsx(Hospitals, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/jamfor/kallsystem",
      element: /*#__PURE__*/_jsx(InformationSources, _objectSpread({}, props))
    }), /*#__PURE__*/_jsx(Route, {
      path: "/jamfor/*",
      element: /*#__PURE__*/_jsx(TypeRoutes, _objectSpread({}, props))
    })]
  });
}